/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable class-methods-use-this */
import { FullStory, init } from '@fullstory/browser';
export class FullStoryTracker {
    constructor(orgId) {
        this.cancelBuild = false;
        this.fs = FullStory;
        if (!orgId) {
            this.cancelBuild = true;
            return;
        }
        this.initialize(orgId);
    }
    initialize(orgId) {
        init({ orgId });
    }
    identify(user) {
        const { userId, displayName, email, userVars, } = user;
        if (!userId || !displayName || !email) {
            return console.error('Fullstory - userId, displayName and email are required.');
        }
        this.fs.identify(userId, {
            ...userVars,
            displayName,
            email: email?.toLocaleLowerCase(),
        });
    }
    // REQUIRED FUNCTION!!!
    trackEvent({ category, ...rest }) {
        this.fs.event(category, rest);
    }
}
